import { render, staticRenderFns } from "./EditGroupBusiness.vue?vue&type=template&id=36661930&"
import script from "./EditGroupBusiness.vue?vue&type=script&lang=js&"
export * from "./EditGroupBusiness.vue?vue&type=script&lang=js&"
import style0 from "./EditGroupBusiness.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports